import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/bianmin/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/bianmin/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/bianmin/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/bianmin/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/bianmin/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/bianmin/status",
      method: "post",
      data
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/bianmin/sort",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/bianmin/select",
      method: "post",
      params: query
    });
  },
};
export default index;